import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import PublicOnlyRoute from './PublicOnlyRoute';
import SignupRoute from './SignupRoute';
import { PATHS } from './navConfig';
import AppLayout from '../components/layout/AppLayout';
import PhoneLoginPage from '../features/auth/PhoneLoginPage';
import VerifyCodePage from '../features/auth/VerifyCodePage';
import SignupPage from '../features/auth/signup/SignupPage';
import DashboardPage from '../features/dashboard/DashboardPage';
import CalendarPage from '../features/calendar/CalendarPage';
import SignupsPage from '../features/signups/SignupsPage';
import LinksPage from '../features/links/LinksPage';
import RemindersPage from '../features/reminders/RemindersPage';
import DonationLinksPage from '../features/donationlinks/DonationLinksPage';
import UsersPage from '../features/users/UsersPage';
import ComposeEmailPage from '../features/email/ComposeEmailPage';
import FundraisingPage from '../features/fundraising/FundraisingPage';
import LunchMenuPage from '../features/lunch/LunchMenuPage';
import RoomParentsPage from '../features/roomparents/RoomParentsPage';
import ConsentPage from '../features/consent/ConsentPage';
import TodosPage from '../features/todos/TodosPage';
import ProfilePage from '../features/profile/ProfilePage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path={PATHS.LOGIN} element={<PublicOnlyRoute><PhoneLoginPage /></PublicOnlyRoute>} />
      <Route path={PATHS.VERIFY} element={<PublicOnlyRoute><VerifyCodePage /></PublicOnlyRoute>} />
      <Route path={PATHS.SIGNUP} element={<SignupRoute><SignupPage /></SignupRoute>} />

      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path={PATHS.DASHBOARD} element={<DashboardPage />} />
        <Route path={PATHS.CALENDAR} element={<CalendarPage />} />
        <Route path={PATHS.SIGNUPS} element={<SignupsPage />} />
        <Route path={PATHS.LINKS} element={<LinksPage />} />
        <Route path={PATHS.REMINDERS} element={<RemindersPage />} />
        <Route path={PATHS.DONATION_LINKS} element={<DonationLinksPage />} />
        <Route path={PATHS.USERS} element={<UsersPage />} />
        <Route path={PATHS.EMAIL} element={<ComposeEmailPage />} />
        <Route path={PATHS.FUNDRAISING} element={<FundraisingPage />} />
        <Route path={PATHS.LUNCH} element={<LunchMenuPage />} />
        <Route path={PATHS.ROOM_PARENTS} element={<RoomParentsPage />} />
        <Route path={PATHS.CONSENT} element={<ConsentPage />} />
        <Route path={PATHS.TODOS} element={<TodosPage />} />
        <Route path={PATHS.PROFILE} element={<ProfilePage />} />
      </Route>

      <Route path="*" element={<Navigate to={PATHS.DASHBOARD} replace />} />
    </Routes>
  );
}
